import React from "react";
import "./CopyableLabel.scss";

import { Icon } from "react-icons-kit";
import { copy as copyIcon } from "react-icons-kit/feather/";

class CopyableLabel extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { success: false };
  }

  onCopyClick() {
    //debugger;
    let { text } = this.props;

    // Does not work without https!
    try {
      copyTextToClipboard(text);
    } catch (error) {
      console.error(error);
    }

    this.setState({ success: true });
    setTimeout(() => {
      this.setState({ success: false });
    }, 500);
  }

  render() {
    let { text } = this.props;

     
    var buttonCssClass = this.state.success ? " success" : "";

    return (
      <div className="copyable-label">
        <p>{text}</p>
        <button className={buttonCssClass} onClick={this.onCopyClick.bind(this)}><Icon size={24} icon={copyIcon} /></button>
      </div>
    );
  }
}

export default CopyableLabel;

function copyTextToClipboard(text) {

  navigator.clipboard.writeText(text).then(function() {
    /* clipboard successfully set */
  }, function() {
    /* clipboard write failed */
  });

/*   var ta = document.createElement("textarea");
  ta.style.position = "fixed";
  ta.style.top = 0;
  ta.style.left = 0;
  ta.style.width = "2em";
  ta.style.height = "2em";
  ta.style.padding = 0;
  ta.style.border = "none";
  ta.style.outline = "none";
  ta.style.boxShadow = "none";
  ta.style.background = "transparent";
  ta.value = "text";
  document.body.appendChild(ta);
  ta.focus();
  ta.select();
  window.getSelection();
  try {
    var successful = document.execCommand("copy");
    var msg = successful ? "successful" : "unsuccessful";
  } catch (err) {
    console.error(err);
  }
  document.body.removeChild(ta); */
}
